import {
    AnyFactoryGame, DysonSphere,
    EditFacilityPayload,
    EditFacilityUserInput,
    EditFactoryPayload,
    EditFactoryUserInput, FactoryGameType,
    IFacility, Satisfactory
} from "../types";
import {SatisfactoryAPI} from "../../api/FactoryGame/index";

export async function editFacility(facility: IFacility<AnyFactoryGame>, inputPartialFacility: EditFacilityUserInput | EditFactoryUserInput) {
    const payload = {
        ...inputPartialFacility,
        id: facility.id,
        parentFacility: facility.parentFacility?.id ?? null,
    };
    switch (true) {
        case facility.type === 'Facility':
            await SatisfactoryAPI.Facility.editFacility(payload as EditFacilityPayload);
            break;
        case facility.type === 'Factory' && facility.game === FactoryGameType.Satisfactory:
            await SatisfactoryAPI.Facility.editFactory(payload as EditFactoryPayload<Satisfactory>);
            break;
        case facility.type === 'Factory' && facility.game === FactoryGameType.DysonSphere:
            await SatisfactoryAPI.Facility.editFactory(payload as EditFactoryPayload<DysonSphere>);
            break;
    }
}
